import { useEffect } from 'react';
import { FormInstance } from 'antd';
import { isEqual } from 'lodash';
import { mergeNationalAddress, NationalAddress } from '~/utils/nationalAddress';

const useNationalAddressFormSync = (
  form: FormInstance,
  apiData: NationalAddress | null | undefined,
  savedData: NationalAddress | null | undefined,
  ready = true,
): void => {
  useEffect(() => {
    if (!ready) return;
    const current = form.getFieldValue(['reviewCompanyInformation', 'nationalAddress']);
    const merged = mergeNationalAddress(apiData, savedData, current);
    if (!isEqual(current, merged)) {
      form.setFieldsValue({ reviewCompanyInformation: { nationalAddress: merged } });
    }
  }, [apiData, form, savedData, ready]);
};

export default useNationalAddressFormSync;
